import React, { useEffect, useState } from "react";

import Breadcrumb from "../components/Reusable/Breadcrumb";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

// import { InputAdornment, TextField } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";

// Lista jezika
const languages = [
  { code: "sr", name: "Srpski", flag: "/images/sr.png" },
  // { code: "en", name: "Engleski", flag: "/images/en.png" },
  { code: "hr", name: "Hrvatski", flag: "/images/hr.png" },
  // { code: "bg", name: "Bugarski", flag: "/images/bg.png" },
  { code: "mk", name: "Makedonski", flag: "/images/mk.png" },
  { code: "ba", name: "Bosanski", flag: "/images/ba.png" },
  // { code: "hu", name: "Mađarski", flag: "/images/hu.png" },
  { code: "sl", name: "Slovenački", flag: "/images/sl.png" },
  // { code: "al", name: "Albanski", flag: "/images/al.png" },
];

const Language = () => {
  const [searchQueryGlobal, setSearchQueryGlobal] = useState("");
  const [filteredLanguages, setFilteredLanguages] = useState(languages);
  const { t } = useTranslation();

  // Debounce za pretragu
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (searchQueryGlobal === "") {
        setFilteredLanguages(languages);
      } else {
        setFilteredLanguages(
          languages.filter((lang) =>
            lang.name.toLowerCase().includes(searchQueryGlobal.toLowerCase())
          )
        );
      }
    }, 300); // Odeljenje od 300ms da se sačeka da korisnik završi sa kucanjem

    return () => clearTimeout(timeoutId); // Čisti timeout kad se pretraga menja
  }, [searchQueryGlobal]);

  return (
    <div className="language-main-container">
      <div className="language-breadcrumb-container">
        <Breadcrumb title={t("choose_language")} returnPage="/settings" />
        {/* <div className="language-item-search">
          <TextField
            label="Pretraga..."
            className="search-input-products-global-page"
            fullWidth
            size="small"
            value={searchQueryGlobal}
            onChange={(e) => setSearchQueryGlobal(e.target.value)}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />{" "}
                  </InputAdornment>
                ),
              },
            }}
          />
        </div> */}
      </div>
      <div className="language-list-container">
        <div className="language-list-items">
          {filteredLanguages.map((language) => (
            <div
              key={language.code}
              className={`language-list-item ${
                language.code === i18next.language ? "active" : ""
              }`}
              onClick={() => i18next.changeLanguage(language.code)}
            >
              <div className="language-list-item-name">
                <div className="language-list-item-name-content">
                  <img
                    src={language.flag}
                    className="img-fluid"
                    alt={language.name}
                  />{" "}
                  {language.name}
                </div>
                {language.code === i18next.language && (
                  <img
                    src="/images/check-education.png"
                    className="img-fluid"
                    alt="selected"
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Language;
